
import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const ShopAPI = {

  getAll: async function (cancel = false) {
    const response = await api.request({
      url: "/api/admin/subcategories",
      method: "GET",
      signal: cancel ? cancelApiObject[this.getAll.name].handleRequestCancellation().signal : undefined,
    })
    return response.data
  },
  create: async function (shop, cancel = false) {
    const response = await api.request({
      url: `/api/admin/subcategories`,
      method: "POST",
      data: shop,
      headers: { "Content-Type": "multipart/form-data" },
      signal: cancel ? cancelApiObject[this.create.name].handleRequestCancellation().signal : undefined,
    })
    return response.data;
  },
  delete: async function (id, cancel = false) {
    const response = await api.request({
      url: `/api/admin/subcategories/${id}`,
      method: "DELETE",
      signal: cancel ? cancelApiObject[this.delete.name].handleRequestCancellation().signal : undefined,
    })
    return response.data;
  },
  update: async function (shop,id,cancel = false) {
    const response = await api.request({
      url: `/api/admin/subcategories/${id}`,
      method: "POST",
      data: shop,
      headers: { "Content-Type": "multipart/form-data" },
      signal: cancel ? cancelApiObject[this.update.name].handleRequestCancellation().signal : undefined,
    })
    return response.data
  },
  get: async function (id,cancel = false) {
    const response = await api.request({
      url: `/api/admin/subcategories/${id}`,
      method: "GET",
      signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
    })
    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(ShopAPI)